exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1.5rem;padding:1.5rem 0}", ""]);

// exports
